export const FINANCE_TIME_ZONE = "Europe/Moscow";

const partsFormatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: FINANCE_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
});
function localParts(instant: Date): number[] {
    const parts = partsFormatter.formatToParts(instant);
    return ["year", "month", "day", "hour", "minute", "second"].map((key) => Number(parts.find((part) => part.type === key)?.value));
}
function utcMillis(parts: number[]): number { return Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]); }

// datetime-local contains wall-clock fields, not the computer's local timezone.
export function financeDateToUTC(value: string): string {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value);
    if (!match) throw new Error("Введите дату и время в часовом поясе Europe/Moscow.");
    const wanted = match.slice(1).map((part) => Number(part || "0"));
    const wall = utcMillis(wanted);
    let candidate = wall;
    for (let i = 0; i < 3; i++) candidate += wall - utcMillis(localParts(new Date(candidate)));
    if (localParts(new Date(candidate)).some((part, index) => part !== wanted[index])) {
        throw new Error("Некорректная дата или время Europe/Moscow.");
    }
    return new Date(candidate).toISOString();
}

export function formatFinanceDate(value?: string): string {
    if (!value) return "—";
    const instant = new Date(value);
    if (!Number.isFinite(instant.getTime())) return "Дата неизвестна";
    return new Intl.DateTimeFormat("ru-RU", {
        timeZone: FINANCE_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23",
    }).format(instant);
}

// Calendar days below are Moscow days written as YYYY-MM-DD.
const dayFormatter = new Intl.DateTimeFormat("en-GB", {timeZone: FINANCE_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit"});
const DAY_MS = 24 * 60 * 60 * 1000;

export function financeDay(value: string | Date): string {
    const parts = dayFormatter.formatToParts(typeof value === "string" ? new Date(value) : value);
    const part = (type: string): string => parts.find((p) => p.type === type)?.value || "";
    return `${part("year")}-${part("month")}-${part("day")}`;
}
export function financeToday(now: Date = new Date()): string { return financeDay(now); }
function dayMillis(day: string): number { return Date.UTC(Number(day.slice(0, 4)), Number(day.slice(5, 7)) - 1, Number(day.slice(8, 10))); }
export function addFinanceDays(day: string, days: number): string { return new Date(dayMillis(day) + days * DAY_MS).toISOString().slice(0, 10); }
export function financeDayDiff(from: string, to: string): number { return Math.round((dayMillis(to) - dayMillis(from)) / DAY_MS); }
export function formatFinanceDay(day: string): string { return `${day.slice(8, 10)}.${day.slice(5, 7)}.${day.slice(0, 4)}`; }

export function formatFinanceDayTitle(value: string): string {
    return new Intl.DateTimeFormat("ru-RU", {timeZone: FINANCE_TIME_ZONE, weekday: "short", day: "numeric", month: "long", year: "numeric"}).format(new Date(value));
}
export function formatFinanceTime(value: string): string {
    return new Intl.DateTimeFormat("ru-RU", {timeZone: FINANCE_TIME_ZONE, hour: "2-digit", minute: "2-digit", hourCycle: "h23"}).format(new Date(value));
}
export function formatFinanceMoment(value?: string): string {
    if (!value) return "—";
    return new Intl.DateTimeFormat("ru-RU", {timeZone: FINANCE_TIME_ZONE, day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23"}).format(new Date(value));
}
